import { Link } from "react-router-dom";
import igorPhoto from "@/assets/igor-nikitin-card.jpg";
import andreyPhoto from "@/assets/andrey-maingardt-profile.jpg";

const FounderSection = ({ headingAs: Heading = "h2" }: { headingAs?: "h1" | "h2" }) => (
  <section id="founder" className="py-16 md:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Heading className="mb-10 font-heading text-3xl leading-[1.12] tracking-tight text-foreground sm:text-4xl lg:text-[2.75rem]">
        Команда <span className="text-accent">WMT AI</span>
      </Heading>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <Link
          to="/team/igor_nikitin"
          aria-label="Подробнее об Игоре Никитине"
          className="group block aspect-[4/5] w-full overflow-hidden rounded-[24px] border border-border bg-card shadow-[0_12px_40px_-24px_rgba(0,0,0,0.28)] transition-shadow duration-300 hover:shadow-[0_18px_48px_-24px_rgba(0,0,0,0.36)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4"
        >
          <article className="flex h-full flex-col">
            <img
              src={igorPhoto}
              alt="Игорь Никитин"
              className="h-[44%] w-full object-cover object-center"
              loading="eager"
            />
            <div className="flex flex-1 flex-col p-5 sm:p-7">
              <h2 className="font-heading text-2xl leading-tight text-foreground sm:text-[28px]">Игорь Никитин</h2>
              <p className="mt-1 font-['Roboto_Flex'] text-sm font-medium leading-5 text-accent">
                Основатель и CEO WMT AI
              </p>
              <p className="mb-5 mt-4 font-['Roboto_Flex'] text-sm italic leading-5 text-muted-foreground sm:text-[15px]">
                «Моя цель - бизнес, в котором собственник получает удовольствие от управления AI-Native компанией».
              </p>
              <span className="wmt-cta wmt-cta--dark mt-auto self-start px-6 text-sm">
                <span className="optical-center">Подробнее</span>
              </span>
            </div>
          </article>
        </Link>

        <Link
          to="/andrey_meinhardt"
          aria-label="Подробнее об Андрее Майнгардте"
          className="group block aspect-[4/5] w-full overflow-hidden rounded-[24px] border border-border bg-card shadow-[0_12px_40px_-24px_rgba(0,0,0,0.28)] transition-shadow duration-300 hover:shadow-[0_18px_48px_-24px_rgba(0,0,0,0.36)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4"
        >
          <article className="flex h-full flex-col">
            <img
              src={andreyPhoto}
              alt="Андрей Майнгардт"
              className="h-[44%] w-full object-cover object-center"
              loading="eager"
            />
            <div className="flex flex-1 flex-col p-5 sm:p-7">
              <h2 className="font-heading text-2xl leading-tight text-foreground sm:text-[28px]">Андрей Майнгардт</h2>
              <p className="mt-1 font-['Roboto_Flex'] text-sm font-medium leading-5 text-accent">
                Директор по стратегии WMT AI
              </p>
              <p className="mb-5 mt-4 font-['Roboto_Flex'] text-sm italic leading-5 text-muted-foreground sm:text-[15px]">
                «В прогнозах стараюсь быть аккуратным: отделяю факты от предположений и ставлю конкретные даты».
              </p>
              <span className="wmt-cta wmt-cta--dark mt-auto self-start px-6 text-sm">
                <span className="optical-center">Подробнее</span>
              </span>
            </div>
          </article>
        </Link>

        <Link
          to="/team/yulia_boltutskaya"
          aria-label="Подробнее о Юлии Болтуцкой"
          className="group block aspect-[4/5] w-full overflow-hidden rounded-[24px] border border-border bg-card shadow-[0_12px_40px_-24px_rgba(0,0,0,0.28)] transition-shadow duration-300 hover:shadow-[0_18px_48px_-24px_rgba(0,0,0,0.36)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4"
        >
          <article className="flex h-full flex-col">
            <img
              src="/images/yulia-boltutskaya-wide.jpg"
              alt="Юлия Болтуцкая"
              className="h-[44%] w-full object-cover object-center"
              loading="eager"
            />
            <div className="flex flex-1 flex-col p-5 sm:p-7">
              <h2 className="font-heading text-2xl leading-tight text-foreground sm:text-[28px]">Юлия Болтуцкая</h2>
              <p className="mt-1 font-['Roboto_Flex'] text-sm font-medium leading-5 text-accent">
                Исполнительный директор WMT AI
              </p>
              <p className="mb-5 mt-4 font-['Roboto_Flex'] text-sm italic leading-5 text-muted-foreground sm:text-[15px]">
                «Мы начинаем не с выбора технологии, а с вопроса: где бизнес сегодня теряет деньги, клиентов или время?»
              </p>
              <span className="wmt-cta wmt-cta--dark mt-auto self-start px-6 text-sm">
                <span className="optical-center">Подробнее</span>
              </span>
            </div>
          </article>
        </Link>
      </div>
    </div>
  </section>
);

export default FounderSection;
